import { c as _c } from "react/compiler-runtime";
const MoneyRow = t0 => {
  const $ = _c(8);
  const {
    label,
    value,
    currency
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <p className="text-body-2 text-tertiary">{label}</p>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== currency || $[3] !== value) {
    t2 = renderMoney(value, currency);
    $[2] = currency;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex items-center justify-between">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
const renderMoney = (value: number, currency: string) => {
  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol'
  }).format(value);
  const isNegative = value < 0;
  let currencySymbol: string;
  let number: string;
  if (isNegative) {
    currencySymbol = formattedValue.substring(0, 2);
    number = formattedValue.substring(2);
  } else {
    currencySymbol = formattedValue.charAt(0);
    number = formattedValue.substring(1);
  }
  return <div className="flex items-center justify-between">
      <p className={`text-snippet-2 ${isNegative ? 'text-error' : ''}`}>
        <span className={isNegative ? 'text-error' : 'text-tertiary'}>{currencySymbol}</span>
        <span data-dd-privacy="mask">{number}</span>
      </p>
    </div>;
};
export default MoneyRow;